module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.shapes), function(s) {
    return (_vm.layers[s.layerId].visible) ? [(s.type == 'marker') ? _c('gmap-marker', {
      key: s.id,
      attrs: {
        "position": s.position,
        "icon": {
          url: s.icon,
          scaledSize: _vm.markerIconSize,
          anchor: _vm.markerIconAnchor
        },
        "clickable": true
      },
      on: {
        "click": function($event) {
          _vm.$bus.$emit('toggleMarkerInfo', s)
        }
      }
    }) : _vm._e(), _vm._v(" "), (s.type == 'dot') ? _c('gmap-marker', {
      key: s.id,
      attrs: {
        "position": s.position,
        "icon": {
          url: s.icon,
          scaledSize: _vm.dotIconSize,
          anchor: _vm.dotIconAnchor
        },
        "clickable": true,
        "draggable": true
      },
      on: {
        "click": function($event) {
          _vm.$bus.$emit('toggleDotInfo', s)
        },
        "dragend": function($event) {
          _vm.updateDotPosition(s, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (s.type == 'polygon') ? _c('gmap-polygon', {
      key: s.id,
      attrs: {
        "draggable": true,
        "editable": true,
        "options": {
          strokeColor: s.color,
          fillColor: s.color,
          strokeOpacity: 0.8,
          strokeWeight: 3,
          fillOpacity: 0.35
        },
        "path": s.path
      },
      on: {
        "path_changed": function($event) {
          _vm.updatePolygonPath(s, $event)
        },
        "rightclick": function($event) {
          _vm.removePolygonPoint(s, $event)
        },
        "click": function($event) {
          _vm.showPolygonInfo(s, $event)
        }
      }
    }) : _vm._e()] : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-411d49ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/Markers.vue
// module id = 471
// module chunks = 0